<template>
    <div>
        <div style="height:auto;" class="p-4" v-if="!photoPageId">
            <h4 class="font-weight-light mb-2">
                Select photo page design
            </h4>
            <hr>
            <h5 class="font-weight-light mb-2 text-teal">
                Without Captions
            </h5>
            <div class="row p-0 m-0 mt-4">
                <div class="photo-page-templates mr-2 mb-2" @click="selectPhotoPage(1)" style="background-image: url('https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/1.png');">
                </div>
                <div class="photo-page-templates mr-2 mb-2" @click="selectPhotoPage(2)" style="background-image: url('https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/2.png');">
                </div>
                <div class="photo-page-templates mr-2 mb-2" @click="selectPhotoPage(4)" style="background-image: url('https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/4.png');">
                </div>
                <div class="photo-page-templates" @click="selectPhotoPage(6)" style="background-image: url('https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/6.png');">
                </div>
            </div>
            <hr>
            <h5 class="font-weight-light mb-2 text-teal">
                With Captions
            </h5>
            <div class="row p-0 m-0 mt-4">
                <div class="photo-page-templates mr-2 mb-2" @click="selectPhotoPage(11)" style="background-image: url('https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/1.png');">
                </div>
                <div class="photo-page-templates mr-2 mb-2" @click="selectPhotoPage(22)" style="background-image: url('https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/2.png');">
                </div>
                <div class="photo-page-templates mr-2 mb-2" @click="selectPhotoPage(44)" style="background-image: url('https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/4.png');">
                </div>
                <div class="photo-page-templates" @click="selectPhotoPage(66)" style="background-image: url('https://stage-followupcrm.s3.us-east-2.amazonaws.com/photo-page/6.png');">
                </div>
            </div>
        </div>
        <div v-else>
            <div style="height: auto;">
                <span class="cursor-pointer text-sm text-teal" @click="goBackToPhotoPageTemplates()"><img src="/images/back-arrow-followup.png"  class="proposal-setting-back-arrow float-left pt-1"> Go Back</span>

                <photo-page-template-1 v-if="photoPageId == 1" :section="section" :proposal="proposal"></photo-page-template-1>
                <photo-page-template-2 v-if="photoPageId == 2" :section="section" :proposal="proposal"></photo-page-template-2>
                <photo-page-template-4 v-if="photoPageId == 4" :section="section" :proposal="proposal"></photo-page-template-4>
                <photo-page-template-6 v-if="photoPageId == 6" :section="section" :proposal="proposal"></photo-page-template-6>
                <photo-page-template-11 v-if="photoPageId == 11" :section="section" :proposal="proposal"></photo-page-template-11>
                <photo-page-template-22 v-if="photoPageId == 22" :section="section" :proposal="proposal"></photo-page-template-22>
                <photo-page-template-44 v-if="photoPageId == 44" :section="section" :proposal="proposal"></photo-page-template-44>
                <photo-page-template-66 v-if="photoPageId == 66" :section="section" :proposal="proposal"></photo-page-template-66>
            </div>
        </div>
    </div>
</template>
<script>
    import PhotoPageTemplate1 from "./photo-pages/photo-page-template-1.vue";
    import axios from "axios";
    import ImageCropper from "../shared/image-cropper.vue";
    export default {
        components: {ImageCropper, PhotoPageTemplate1},
        props: ['section', 'proposal'],
        data(){
            return {
                photoPageId: this.section.photo_page_id,
                photoPageData: this.section.photo_page_data,
                photoPageUrl: this.section.photo_page_url,
            }
        },
        methods: {
            selectPhotoPage(photoPage){
                console.log(photoPage);
                axios.post(route('proposal.select-photo-page'), {sectionId: this.section.id, photoPageId: photoPage}).then((response) => {
                    console.log('response', response);
                    this.photoPageId = photoPage;
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                });
                this.$parent.sectionDataForPhoto.photo_page_id = photoPage;
            },
            goBackToPhotoPageTemplates(){
                this.photoPageId = null;
            }
        },
        mounted() {

        }
    }
</script>
<style>
    .photo-page-templates{
        background-size: contain;
        width: 204px;
        height: 265px;
        border-radius: 5px;
        box-shadow: 0px 0px 10px 0px silver;
    }
    .photo-page-templates:hover {
        box-shadow: 0px 0px 10px 0px #01b1af;
        cursor: pointer;
    }
</style>
